import { apiClient } from '@/lib/api-client'

export interface MoveEnvelopeToVaultParams {
  envelopeId: string
  vaultId: string
}

export const MOVE_ENVELOPE_QUERY_KEYS = [
  'envelopes',
  'envelope',
  'vaults',
  'vault-items',
]

export const moveEnvelopeToVault = async ({
  envelopeId,
  vaultId,
}: MoveEnvelopeToVaultParams): Promise<void> => {
  await apiClient.post(`/v1/ecm/envelopes/${envelopeId}/to/${vaultId}`)
}
